import _styled from "styled-components";
var _class;
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { runInAction } from "mobx";
import { observer } from "mobx-react";
import { Component } from "react";
import ChartPanel from "../Custom/Chart/ChartPanel";
import measureElement from "../HOCs/measureElement";
import withControlledVisibility from "../HOCs/withControlledVisibility";
import ChartDisclaimer from "./ChartDisclaimer";
import Timeline from "./Timeline/Timeline";
import { withTheme } from "styled-components";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
let BottomDock = observer(_class = class BottomDock extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "refToMeasure", null);
  }
  handleClick() {
    runInAction(() => {
      this.props.viewState.topElement = "BottomDock";
    });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.heightFromMeasureElementHOC !== this.props.heightFromMeasureElementHOC) {
      var _this$props$heightFro;
      this.props.viewState.setBottomDockHeight((_this$props$heightFro = this.props.heightFromMeasureElementHOC) !== null && _this$props$heightFro !== void 0 ? _this$props$heightFro : 0);
    }
  }
  render() {
    const {
      terria
    } = this.props;
    const top = terria.timelineStack.top;
    return /*#__PURE__*/_jsxs(_StyledDiv, {
      className: "".concat(this.props.viewState.topElement === "BottomDock" ? "top-element" : ""),
      ref: element => {
        if (element !== null) {
          this.refToMeasure = element;
        }
      },
      tabIndex: 0,
      onClick: this.handleClick.bind(this),
      children: [/*#__PURE__*/_jsx("div", {
        id: "TJS-BottomDockFirstPortal"
      }), !this.props.viewState.useSmallScreenInterface && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ChartDisclaimer, {
          terria: terria,
          viewState: this.props.viewState
        }), /*#__PURE__*/_jsx(ChartPanel, {})]
      }), top && /*#__PURE__*/_jsx(Timeline, {
        terria: terria,
        elementConfig: this.props.terria.elements.get("timeline")
      }), /*#__PURE__*/_jsx("div", {
        id: "TJS-BottomDockLastPortal"
      })]
    });
  }
}) || _class;
export default withControlledVisibility(withTheme(measureElement(BottomDock, false)));
var _StyledDiv = _styled("div").withConfig({
  displayName: "BottomDock___StyledDiv",
  componentId: "sc-1v3n1k8-0"
})(["bottom:0;right:0;position:relative;"]);